export const RELATIONSHIP_TYPES = {
    parent_company: { label: 'Parent Company', category: 'business' },
    subsidiary: { label: 'Subsidiary', category: 'business' },
    partner: { label: 'Business Partner', category: 'business' },
    referral_source: { label: 'Referral Source', category: 'business' },
    works_for: { label: 'Works For', category: 'personal' },
    reports_to: { label: 'Reports To', category: 'personal' },
    colleague: { label: 'Colleague', category: 'personal' },
    subcontractor_of: { label: 'Subcontractor Of', category: 'project' },
    supplies_to: { label: 'Supplies To', category: 'project' },
    works_on_job: { label: 'Works on Same Job', category: 'project' },
};
export const TASK_STATUSES = {
    todo: { label: 'To Do', color: '#6b7280' },
    in_progress: { label: 'In Progress', color: '#3b82f6' },
    review: { label: 'Review', color: '#f59e0b' },
    done: { label: 'Done', color: '#10b981' },
    blocked: { label: 'Blocked', color: '#ef4444' },
};
export const TASK_PRIORITIES = {
    low: { label: 'Low', color: '#9ca3af' },
    normal: { label: 'Normal', color: '#3b82f6' },
    high: { label: 'High', color: '#f59e0b' },
    urgent: { label: 'Urgent', color: '#ef4444' },
};
export const PROJECT_STATUSES = {
    active: { label: 'Active', color: '#10b981' },
    on_hold: { label: 'On Hold', color: '#f59e0b' },
    completed: { label: 'Completed', color: '#6b7280' },
    cancelled: { label: 'Cancelled', color: '#ef4444' },
};
export const DEFAULT_COLUMNS = [
    { name: 'To Do', statusKey: 'todo', color: '#6b7280' },
    { name: 'In Progress', statusKey: 'in_progress', color: '#3b82f6' },
    { name: 'Review', statusKey: 'review', color: '#f59e0b' },
    { name: 'Done', statusKey: 'done', color: '#10b981' },
];
// Databuild Legacy Transaction Types (TType)
// These MUST match the legacy system exactly:
// TType 1 = CLM (Claim to Client)
// TType 2 = REC (Receipt from Client)
// TType 3 = INV (Supplier Invoice)
// TType 4 = PAY (Payment to Supplier)
// TType 5 = Credit Note
// TType 6 = Journal Entry
// TType 7 = Retention Release
export const TRANSACTION_TYPES = {
    1: { label: 'Client Claim', code: 'CLM', color: '#17a2b8', icon: 'bi-receipt' },
    2: { label: 'Client Receipt', code: 'REC', color: '#28a745', icon: 'bi-cash' },
    3: { label: 'Supplier Invoice', code: 'INV', color: '#dc3545', icon: 'bi-file-earmark-text' },
    4: { label: 'Supplier Payment', code: 'PAY', color: '#28a745', icon: 'bi-cash-stack' },
    5: { label: 'Credit Note', code: 'CRN', color: '#ffc107', icon: 'bi-file-earmark-minus' },
    6: { label: 'Journal Entry', code: 'JNL', color: '#6c757d', icon: 'bi-journal-text' },
    7: { label: 'Retention Release', code: 'RET', color: '#6f42c1', icon: 'bi-unlock' },
};
export const COST_TYPES = {
    materials: { label: 'Materials' },
    subcontractor: { label: 'Sub Contractor' },
    labour: { label: 'Labour' },
    equipment: { label: 'Equipment' },
    professional: { label: 'Professional Services' },
    other: { label: 'Other' },
};
export const BANK_CODES = {
    'ANZ': 'ANZ',
    'CBA': 'CBA',
    'Commonwealth': 'CBA',
    'NAB': 'NAB',
    'National': 'NAB',
    'WBC': 'WBC',
    'Westpac': 'WBC',
    'STG': 'STG',
    'St George': 'STG',
    'BOQ': 'BOQ',
    'Bank of Queensland': 'BOQ',
    'BEN': 'BEN',
    'Bendigo': 'BEN',
};
export const PAYMENT_BATCH_STATUSES = {
    draft: { label: 'Draft', color: '#6c757d' },
    authorized: { label: 'Authorized', color: '#0d6efd' },
    processed: { label: 'Processed', color: '#198754' },
    cancelled: { label: 'Cancelled', color: '#dc3545' },
};
// Variance threshold configuration
export const VARIANCE_THRESHOLDS = {
    autoApprovePercentage: 2.0, // 2% variance auto-approved
    autoApproveAmount: 50.00, // $50 variance auto-approved
    managerApprovalPercentage: 10.0, // 10%+ requires manager approval
    managerApprovalAmount: 500.00, // $500+ requires manager approval
};
// Status display constants
export const MATCH_STATUSES = {
    pending: { label: 'Pending', color: '#6c757d' },
    matched: { label: 'Matched', color: '#0d6efd' },
    variance: { label: 'Variance', color: '#ffc107' },
    resolved: { label: 'Resolved', color: '#198754' },
};
export const APPROVAL_STATUSES = {
    pending: { label: 'Pending', color: '#6c757d' },
    approved: { label: 'Approved', color: '#198754' },
    rejected: { label: 'Rejected', color: '#dc3545' },
};
export const VARIANCE_TYPES = {
    price_over: { label: 'Price Over', color: '#dc3545', icon: 'bi-arrow-up-circle' },
    price_under: { label: 'Price Under', color: '#198754', icon: 'bi-arrow-down-circle' },
    quantity_short: { label: 'Quantity Short', color: '#ffc107', icon: 'bi-dash-circle' },
    quantity_over: { label: 'Quantity Over', color: '#dc3545', icon: 'bi-plus-circle' },
    missing_item: { label: 'Missing Item', color: '#6c757d', icon: 'bi-x-circle' },
    adhoc_item: { label: 'Adhoc Item', color: '#0d6efd', icon: 'bi-plus-square' },
};
export const VARIANCE_ACTION_TYPES = {
    request_credit: { label: 'Request Credit Note', description: 'Request credit note from supplier for overcharge' },
    accept_no_action: { label: 'Accept (No Action)', description: 'Accept the variance without any price updates' },
    accept_update_catalogue: { label: 'Accept & Update Catalogue', description: 'Accept and update the catalogue estimate price' },
    accept_update_supplier: { label: 'Accept & Update Supplier Price', description: 'Accept and update the supplier price list' },
    add_to_catalogue: { label: 'Add to Catalogue', description: 'Add this adhoc item to the catalogue' },
    create_backorder: { label: 'Create Backorder', description: 'Create a backorder for missing/short items' },
    apply_retention: { label: 'Apply Retention', description: 'Apply retention for quality/completion issues' },
};
export const BACKORDER_REASONS = {
    short_delivery: { label: 'Short Delivery', description: 'Less quantity delivered than ordered' },
    damaged: { label: 'Damaged Goods', description: 'Items received were damaged' },
    missing: { label: 'Missing Items', description: 'Items not included in delivery' },
    quality_issue: { label: 'Quality Issue', description: 'Items rejected due to quality' },
    supplier_backorder: { label: 'Supplier Backorder', description: 'Items on backorder with supplier' },
};
export const GRN_STATUSES = {
    received: { label: 'Received', color: '#198754' },
    partial: { label: 'Partial', color: '#ffc107' },
    damaged: { label: 'Damaged', color: '#dc3545' },
    returned: { label: 'Returned', color: '#6c757d' },
};
// Claim stage status display constants
export const CLAIM_STAGE_STATUSES = {
    pending: { label: 'Pending', color: '#6c757d', bgColor: '#f8f9fa' },
    ready: { label: 'Ready', color: '#0d6efd', bgColor: '#e7f1ff' },
    posted: { label: 'Posted', color: '#198754', bgColor: '#d1e7dd' },
    paid: { label: 'Paid', color: '#198754', bgColor: '#c8e6c9' },
};
// ===== Display Constants =====
export const DOCUMENT_STATUSES = {
    draft: { label: 'Draft', color: '#6c757d', bgColor: '#f8f9fa', icon: 'bi-file-earmark' },
    in_review: { label: 'In Review', color: '#0d6efd', bgColor: '#e7f1ff', icon: 'bi-eye' },
    published: { label: 'Published', color: '#198754', bgColor: '#d1e7dd', icon: 'bi-check-circle' },
    archived: { label: 'Archived', color: '#6c757d', bgColor: '#e9ecef', icon: 'bi-archive' },
};
export const WORKFLOW_STATUSES = {
    active: { label: 'Active', color: '#0d6efd', bgColor: '#e7f1ff', icon: 'bi-play-circle' },
    completed: { label: 'Completed', color: '#198754', bgColor: '#d1e7dd', icon: 'bi-check-circle' },
    rejected: { label: 'Rejected', color: '#dc3545', bgColor: '#f8d7da', icon: 'bi-x-circle' },
    cancelled: { label: 'Cancelled', color: '#6c757d', bgColor: '#e9ecef', icon: 'bi-slash-circle' },
};
export const WORKFLOW_STEP_STATUSES = {
    pending: { label: 'Pending', color: '#6c757d', bgColor: '#f8f9fa', icon: 'bi-hourglass' },
    in_progress: { label: 'In Progress', color: '#0d6efd', bgColor: '#e7f1ff', icon: 'bi-play-fill' },
    completed: { label: 'Completed', color: '#198754', bgColor: '#d1e7dd', icon: 'bi-check' },
    rejected: { label: 'Rejected', color: '#dc3545', bgColor: '#f8d7da', icon: 'bi-x' },
    skipped: { label: 'Skipped', color: '#6c757d', bgColor: '#e9ecef', icon: 'bi-skip-forward' },
};
export const MARKUP_TYPES = {
    highlight: { label: 'Highlight', icon: 'bi-highlighter', color: '#ffeb3b' },
    underline: { label: 'Underline', icon: 'bi-type-underline', color: '#2196f3' },
    strikethrough: { label: 'Strikethrough', icon: 'bi-type-strikethrough', color: '#f44336' },
    rectangle: { label: 'Rectangle', icon: 'bi-square', color: '#4caf50' },
    circle: { label: 'Circle', icon: 'bi-circle', color: '#9c27b0' },
    arrow: { label: 'Arrow', icon: 'bi-arrow-up-right', color: '#ff9800' },
    freehand: { label: 'Freehand', icon: 'bi-pencil', color: '#607d8b' },
    text_note: { label: 'Text Note', icon: 'bi-chat-square-text', color: '#3f51b5' },
    approval_stamp: { label: 'Stamp', icon: 'bi-patch-check', color: '#009688' },
};
export const COLLECTION_TYPES = {
    published: { label: 'Published', icon: 'bi-check-circle', color: '#198754' },
    in_review: { label: 'In Review', icon: 'bi-eye', color: '#0d6efd' },
    archive: { label: 'Archive', icon: 'bi-archive', color: '#6c757d' },
    custom: { label: 'Custom', icon: 'bi-folder', color: '#ffc107' },
};
export const NOTIFICATION_TYPES = {
    task_assigned: { label: 'Task Assigned', icon: 'bi-person-plus', priority: 'normal' },
    task_due_soon: { label: 'Task Due Soon', icon: 'bi-clock', priority: 'normal' },
    task_overdue: { label: 'Task Overdue', icon: 'bi-exclamation-triangle', priority: 'high' },
    workflow_completed: { label: 'Workflow Completed', icon: 'bi-check-circle', priority: 'low' },
    workflow_rejected: { label: 'Workflow Rejected', icon: 'bi-x-circle', priority: 'high' },
    comment_added: { label: 'Comment Added', icon: 'bi-chat', priority: 'low' },
    delegated_to_you: { label: 'Delegated to You', icon: 'bi-person-check', priority: 'normal' },
    escalated: { label: 'Escalated', icon: 'bi-arrow-up-circle', priority: 'high' },
};
// Common disciplines for document classification
export const DOCUMENT_DISCIPLINES = [
    'Architectural',
    'Structural',
    'Mechanical',
    'Electrical',
    'Plumbing',
    'Fire Protection',
    'Civil',
    'Landscape',
    'Interior Design',
    'Project Management',
    'Safety',
    'Quality',
    'Commercial',
    'Legal',
    'General',
];
// Common document type codes
export const DOCUMENT_TYPE_CODES = [
    { code: 'DWG', name: 'Drawing' },
    { code: 'SPEC', name: 'Specification' },
    { code: 'RFI', name: 'Request for Information' },
    { code: 'SUB', name: 'Submittal' },
    { code: 'RPT', name: 'Report' },
    { code: 'MTG', name: 'Meeting Minutes' },
    { code: 'COR', name: 'Correspondence' },
    { code: 'CON', name: 'Contract' },
    { code: 'CHG', name: 'Change Order' },
    { code: 'INV', name: 'Invoice' },
    { code: 'CERT', name: 'Certificate' },
    { code: 'PHOTO', name: 'Photograph' },
    { code: 'PLAN', name: 'Plan' },
    { code: 'SCHED', name: 'Schedule' },
    { code: 'OTHER', name: 'Other' },
];
// Purpose display constants
export const TRANSMITTAL_PURPOSES = [
    { value: 'for_approval', label: 'For Approval', color: 'warning' },
    { value: 'for_construction', label: 'For Construction', color: 'success' },
    { value: 'for_information', label: 'For Information', color: 'info' },
    { value: 'for_review', label: 'For Review', color: 'primary' },
    { value: 'for_record', label: 'For Record', color: 'secondary' },
    { value: 'as_requested', label: 'As Requested', color: 'light' },
];
// Sent via display constants
export const TRANSMITTAL_SENT_VIA = [
    { value: 'email', label: 'Email', icon: 'bi-envelope' },
    { value: 'link', label: 'Shared Link', icon: 'bi-link-45deg' },
    { value: 'physical', label: 'Physical', icon: 'bi-box-seam' },
];
// Common disciplines for construction/engineering
export const TRANSMITTAL_DISCIPLINES = [
    'Architectural',
    'Structural',
    'Mechanical',
    'Electrical',
    'Plumbing',
    'Civil',
    'Landscape',
    'Interior Design',
    'Fire Protection',
    'General',
];
// Common document types
export const TRANSMITTAL_DOCUMENT_TYPES = [
    'Drawing',
    'Specification',
    'Schedule',
    'Report',
    'Calculation',
    'Certificate',
    'Manual',
    'Submittal',
    'RFI Response',
    'Variation',
    'Contract Document',
    'Correspondence',
    'Other',
];
// Journal Entry Type Labels
export const JOURNAL_ENTRY_TYPES = {
    po_commitment: { label: 'PO Commitment', description: 'Purchase order commitment recorded' },
    po_commitment_release: { label: 'Commitment Release', description: 'PO commitment released on invoice' },
    supplier_invoice: { label: 'Supplier Invoice', description: 'Supplier invoice recorded' },
    supplier_payment: { label: 'Supplier Payment', description: 'Payment to supplier' },
    progress_claim: { label: 'Progress Claim', description: 'Progress claim to client' },
    client_receipt: { label: 'Client Receipt', description: 'Receipt from client' },
    credit_note: { label: 'Credit Note', description: 'Supplier credit note' },
    retention_release: { label: 'Retention Release', description: 'Retention released' },
    journal_adjustment: { label: 'Journal Adjustment', description: 'Manual journal adjustment' },
    opening_balance: { label: 'Opening Balance', description: 'Opening balance entry' },
};
export const JOURNAL_ENTRY_STATUSES = {
    pending: { label: 'Pending', color: '#ffc107' },
    posted: { label: 'Posted', color: '#198754' },
    reversed: { label: 'Reversed', color: '#dc3545' },
};
export const GL_ACCOUNT_TYPES = {
    asset: { label: 'Asset', normalBalance: 'debit' },
    liability: { label: 'Liability', normalBalance: 'credit' },
    equity: { label: 'Equity', normalBalance: 'credit' },
    revenue: { label: 'Revenue', normalBalance: 'credit' },
    expense: { label: 'Expense', normalBalance: 'debit' },
    commitment: { label: 'Commitment', normalBalance: 'credit' },
};
export const COMMITMENT_STATUSES = {
    open: { label: 'Open', color: '#0d6efd' },
    partially_released: { label: 'Partial', color: '#ffc107' },
    fully_released: { label: 'Released', color: '#198754' },
    cancelled: { label: 'Cancelled', color: '#dc3545' },
};
// Audit Action Constants
export const AUDIT_ACTIONS = {
    1: 'Login',
    2: 'Logout',
    3: 'Create',
    4: 'Update',
    5: 'Delete',
    6: 'Export',
    7: 'Import',
    8: 'Approve',
    9: 'Reject',
    10: 'View',
    11: 'Print',
    12: 'Email',
};
// Calculation Routine Reference
export const CALCULATION_ROUTINES = {
    0: { name: 'Standard', formula: '(Qty / Divisor) * UnitPrice', description: 'Standard calculation with divisor' },
    1: { name: 'Standard (No Round)', formula: '(Qty / Divisor) * UnitPrice', description: 'Standard without rounding' },
    2: { name: 'Linear', formula: 'Qty * UnitPrice', description: 'Direct multiplication' },
    3: { name: 'Area', formula: 'Qty * UnitPrice', description: 'Direct multiplication for area' },
    6: { name: 'Price Only', formula: 'UnitPrice', description: 'Unit price only, quantity ignored' },
    7: { name: '% of Running Total', formula: 'RunningTotal * (Qty / 100)', description: 'Percentage of cumulative total' },
    8: { name: 'Heading', formula: 'No calculation', description: 'Section heading, resets running total' },
    9: { name: 'Sub-Heading', formula: 'No calculation', description: 'Sub-section heading' },
    14: { name: 'Heading (Alt)', formula: 'No calculation', description: 'Alternative heading style' },
    15: { name: '% of Contract', formula: '(Contract + GST) * (Qty / 100)', description: 'Percentage of contract value' },
    16: { name: '% of Bill Total', formula: 'BOQTotal * (Qty / 100)', description: 'Percentage of bill total' },
};
/** System-default margin if neither the override nor the job default is set. */
export const DEFAULT_ALLOWANCE_MARGIN_PERCENT = 10;
/**
 * Compute client price from bare cost using true margin.
 * Returns the bare cost if margin >= 100 (would be infinite — defensive).
 */
export function computeClientFromBare(bareCost, marginPercent) {
    if (marginPercent <= 0)
        return bareCost;
    if (marginPercent >= 100)
        return bareCost; // defensive: 100% margin = infinite price
    return bareCost / (1 - marginPercent / 100);
}
/** Fixed pipeline stages for now — a crmSettings metadata override can come later. */
export const LEAD_STAGES = [
    { key: 'new', label: 'New Lead', color: '#6c757d' },
    { key: 'contacted', label: 'Contacted', color: '#0dcaf0' },
    { key: 'qualified', label: 'Qualified', color: '#0d6efd' },
    { key: 'quoting', label: 'Quoting', color: '#6f42c1' },
    { key: 'tender_sent', label: 'Proposal Sent', color: '#fd7e14' },
    { key: 'won', label: 'Won', terminal: true, color: '#198754' },
    { key: 'lost', label: 'Lost', terminal: true, color: '#dc3545' },
];
/** Canonical group set from Sam's real New Homes Tenders. */
export const TENDER_GROUPS = [
    { key: 'classic_inclusions', title: 'Inclusions', partOfBase: true, subtotalLabel: 'Total Inclusions', sortOrder: 10 },
    { key: 'site_costs', title: 'Site Costs', partOfBase: true, subtotalLabel: 'Total Site Costs', sortOrder: 20 },
    { key: 'statutory', title: 'Statutory & Other Requirements', partOfBase: true, subtotalLabel: 'Total Statutory & Other Requirements', sortOrder: 30 },
    { key: 'basix', title: 'BASIX Requirements', partOfBase: true, subtotalLabel: 'Total BASIX Requirements', sortOrder: 40 },
    { key: 'client_variations', title: 'Client Variations', partOfBase: false, subtotalLabel: 'Total Client Variations', sortOrder: 50 },
    { key: 'provisional', title: 'Provisional Allowances', partOfBase: false, subtotalLabel: 'Total Provisional Allowances', sortOrder: 60 },
];
/** Legacy display names kept for older tenders whose rows used free-text groups. */
export const TENDER_ADJUSTMENT_GROUPS = TENDER_GROUPS.map((g) => g.title);
export const DEFAULT_TENDER_SECTIONS = [
    { key: 'cover_letter', title: 'Cover Letter', body: '', sortOrder: 10 },
    // ---- pricing schedule renders here ----
    { key: 'closing_letter', title: 'Closing', body: 'This Proposal will remain firm for 180 days subject to your acceptance and payment of a non-refundable deposit within 14 days of the proposal date.', sortOrder: 55 },
    {
        key: 'notes',
        title: 'Notes',
        body: [
            'This Proposal is subject to further BASIX requirements, to be confirmed upon completion of the Certificate.',
            'No allowance for any demolition of existing structures, removal or repairs of fences, disconnection or relocation of any services, or removal of existing debris from site.',
            'Owner to arrange disconnection of all services (sewer, water, gas, electricity) in the case of a knock down and rebuild.',
            'No allowance for tree, stump, root system or rubbish removal unless quoted or mentioned in this Proposal.',
            'No allowance for any retaining walls other than those already stated in this Proposal.',
            'All Council contributions including Section 7.11/7.12 (formerly s94) are excluded and shall be paid by the owner.',
            'Unless otherwise quoted — no allowances have been made for Engineering or Council requirements relating to Slab, Site Classification or Salinity; these become variations.',
            'The owner is responsible for connection and metering fees for electricity, telephone and gas.',
            'No allowances for acoustic, bushfire or flood requirements unless quoted; any required assessment reports and resulting requirements are charged as extras.',
            'Should land developer/vendor approval be required, it is the client\'s responsibility to obtain the necessary approvals prior to plan lodgement.',
            'This Proposal is based on all services being available to the subject lot within a standard service run from the connection point to the dwelling.',
            'Should construction not commence within 6 months of the original Proposal date, the price will be reviewed.',
        ].join('\n'),
        sortOrder: 60,
    },
    { key: 'preliminary_agreement', title: 'Preliminary Agreement', body: 'These instructions relate to the preparation of plans, engineering details and obtaining appropriate approvals for building work upon the land. I/We authorise and request you to arrange a site inspection and survey, prepare engineering design, and prepare building plans and specifications based on this Proposal for lodgement with the relevant authorities.', sortOrder: 90 },
    { key: 'acceptance', title: 'Acceptance', body: 'I/We accept this Proposal as attached and give the builder authority to commence preparing the architectural and structural engineer\'s plans for submission. I/We understand that all designs, sketches and plans remain the property of the builder and are subject to copyright.', sortOrder: 95 },
];
